export default __webpack_public_path__ + "static/media/delete-1234819.e11bacc1.svg";